/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { ServiceOrderEditRequest } from '../types/ServiceOrderEdit';
import type { ServiceOrderListResponse } from '../types/ServiceOrderList';

export type ServiceOrdersCreateRequest = ServiceOrderEditRequest;
export type ServiceOrdersCreateResponse = ServiceOrderListResponse;

export type ServiceOrdersCreateQuery = {};

/**
 * POST /dmx-server/service_orders/
 *
 * ```yaml
 * operationId: service_orders_create
 * tags:
 *   - service_orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderEdit'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderEdit'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderEdit'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ServiceOrderList'
 *     description: ''
 * ```
 */
export const serviceOrdersCreateOperation = (rest?: ServiceOrdersCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/service_orders/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/service_orders/' };
  };

/**
 * POST /dmx-server/service_orders/
 *
 * ```yaml
 * operationId: service_orders_create
 * tags:
 *   - service_orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderEdit'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderEdit'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderEdit'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ServiceOrderList'
 *     description: ''
 * ```
 */
export const serviceOrdersCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: ServiceOrdersCreateQuery;
  request: ServiceOrderEditRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<ServiceOrderListResponse>> => {
  const operation = serviceOrdersCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
